'use client'
import React, { useEffect, useState} from 'react'
import {
    APIProvider,
    Map,
    AdvancedMarker,
    useMap,
    InfoWindow,
} from "@vis.gl/react-google-maps"
import {useNavigate } from 'react-router-dom'
import { notification } from './util/NotificationManager';
import NotificationContainer from './NotificationContainer';

export default function Maps(props) {
  const {data, coordinates, onManualPosition, textChange} = props;
  const [position, setPosicion] = useState({ lat: 14.634895669970941, lng: -90.5068875600177 })
  const [openList, setOpenList] = useState([])
  const [isFocused, setIsFocused] = useState(false)
  
  const navigate = useNavigate()
  useEffect(() => {
    if(data.length > 0){
      //console.log("data es cero")
      const falseList = new Array(data.length).fill(false)
      setOpenList(falseList)
    }
  },[data])

  useEffect(() => {
    if(coordinates !== null){
      setIsFocused(false)
    }
  },[coordinates])

  const CambioCoordenada = () => {
    const maps = useMap()
    useEffect(()=>{
      if(coordinates !== null){
        if(!isFocused){
          setPosicion({ lat: coordinates.latitude, lng: coordinates.longitude })
          const gCord = new window.google.maps.LatLng(coordinates.latitude,coordinates.longitude)
          maps.setCenter(gCord)
          setIsFocused(true)
        }
      }
    },[maps])

    return <>
    {coordinates !== null ?(
      <AdvancedMarker
      className='advance-marker-location' 
      position = {position}
      draggable= {true}
      onDragEnd={(e) => {
        const nuevaPos = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        };
        setPosicion(nuevaPos);
        onManualPosition(nuevaPos);
        textChange("del punto fijo")
        //console.log("Nueva ubicación:", nuevaPos);
      }}
      >
        <div className='location-point'></div>
      </AdvancedMarker>
    ):(<></>)}
    </>
  }

  const handleNavigation = (slug) => {
    navigate(`/Cancha/${slug}`);
  };

  const Markers = () => {
    return <>
      {data.map((d, i) => (
        <AdvancedMarker key={d.id_establecimiento} position={new window.google.maps.LatLng(d.Ubi_Latitud,d.Ubi_Longitud)} onClick={() => setTrueOpenList(i,openList,setOpenList)}>
          <div className='imagen-canchas'></div>
        </AdvancedMarker>  
      ))}
      <InfoOpen/>
    </>
  }

  const setTrueOpenList = (index, openList, setOpenList) => {

    const TempArray = [...openList]
      TempArray[index] = true
      setOpenList(TempArray)
  }

  const setFalseOpenList = (index, openList, setOpenList) => {
    const TempArray = [...openList]
      TempArray[index] = false
      setOpenList(TempArray)
  }
  const showDistanceMessage = () =>{
    notification("Esta distancia es en línea reacta desde tu ubicación hasta la cancha seleccionada. Si vas en carro o caminando, puede ser mayor.","warning",10000);
  }
  const showEfectivoMessage = () =>{
    notification("Podés pagar en efectivo.","warning",3000);
  }
  const showTarjetaMessage = () =>{
    notification("Podés pagar con tarjeta.","warning",3000);
  }
  const showTransferenciaMessage = () =>{
    notification("Podés pagar por transferencia bancaria.","warning",3000);
  }
  const showEstacionamientoMessage = () => {
    notification("Area de parqueo disponible","warning",3000);
  }

  const InfoOpen = () => {
    return <>
    <NotificationContainer/>
    {data.map((d, i) => (
      <React.Fragment key={d.id_establecimiento}>
      {openList[i] ? (
        
          <InfoWindow key={d.id_establecimiento} position={new window.google.maps.LatLng((d.Ubi_Latitud + 0.000),(d.Ubi_Longitud + 0.00))} onCloseClick={() => setFalseOpenList(i,openList,setOpenList)}>
            <div key={d.id_establecimiento} className='Pop-up'>
              <h1>{d.nombre}</h1>
              <hr/>
              <div className='contenedor-iconos'>
                <div className='icono-distancia' title='Distancia' onClick={showDistanceMessage}><p>{d.distancia} </p><p> Km*</p></div>
                {d.Efectivo === "Si" &&(
                  <div className='contenedor-icono' title='Efectivo' onClick={showEfectivoMessage}><div className='icono-Efectivo'></div></div>
                )}
                {d.Tarjeta === "Si" &&(
                  <div className='contenedor-icono' title='Tarjeta' onClick={showTarjetaMessage}><div className='icono-Tarjeta'></div></div>
                )}
                {d.Transferencia === "Si" &&(
                  <div className='contenedor-icono' title='Transferencia' onClick={showTransferenciaMessage}><div className='icono-Transferencia'></div></div>
                )}
              {d.Parqueo === "Si" && (
                <div className='icono-parqueo' title='Estacionamiento' onClick={showEstacionamientoMessage}>P</div>
              )}
              {d.WhatsApp !== "" && (
                <a
                  href={`https://wa.me/502${d.WhatsApp}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='link-whatsapp'
                  title='WhatsApp'
                >
                  <div className='contenedor-icono-Whatsapp'><div className='icono-whatsapp'></div></div>
                </a>
              )}
              </div>

              <h4>{d.direccion}</h4>
              <h4>Tel:&nbsp;<a href= {`tel:+502${d.telefono}`}>+502 {d.telefono}</a></h4>
              <h4>
                <a 
                  href= {`https://waze.com/ul?ll=${d.Ubi_Latitud},${d.Ubi_Longitud}`}
                  target='_blank'
                  rel='noopener noreferrer' 
                >
                  Ver en waze
                </a>
              </h4>
              <div className='contenedor-fut'>
                
                  {d.fut5 === 1 && (
                    <div className='contenedor-fut5'>
                      <h4>Fut 5</h4>
                      <table>
                        <thead>
                          <tr>
                            <th><p>Precio</p></th>
                            <th><p>Depósito</p></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th><p>Q.{d.precio_fut5}.00</p></th>
                            <th><p>Q.{d.deposito_fut5}.00</p></th>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                  )}
                  
                  {d.fut7 === 1 && (
                    <div className='contenedor-fut7'>
                      <h4>Fut 7</h4>
                      <table>
                        <thead>
                          <tr>
                            <th><p>Precio</p></th>
                            <th><p>Depósito</p></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th><p>Q.{d.precio_fut7}.00</p></th>
                            <th><p>Q.{d.deposito_fut7}.00</p></th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                
              </div>
              <p className='Pop-up_Reservar' onClick={() => handleNavigation(d.slug)}>{d.Estado === "Afiliado" ? "Reservar": "Ver"}</p>
            </div> 
          </InfoWindow>  
      ):(<></>)}
      </React.Fragment>
    ))}
    </>

  }

    return (
      <div className='Contenido-Mapa'>
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            <Map
              style={{
                width: 'auto',
              }}
              defaultZoom={13}
              defaultCenter={position}
              gestureHandling={'greedy'}
              disableDefaultUI={true}
              fullscreenControl={false}
              mapId={'34dcc3b23c5a342b'}
            >
                <CambioCoordenada/> 
              {data.length > 0 ? (
                <Markers/>
              ):(
                <></>
              )}
            </Map>
          </APIProvider>
      </div>  
    )
  }

